import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  CustomInput,
  Form,
  FormGroup,
  Input,
  Label,
  Row } from 'reactstrap';
import Loader from '../../components/Loader';

class DTCFindMerchant extends Component {
  state = {
    noMerchant: false,
    validZip: false,
    showResults: false,
    merchantSelected: false,
    selected: ''
  }

  handleNoMerchantCheck = () => {
    this.setState({
      noMerchant: !this.state.noMerchant,
      showResults: false,
      merchantSelected: !this.state.noMerchant
    });
  }

  handleFormValidation = (evt) => {
    if (evt.target.value.length === 5) {
      this.setState({ validZip: true });
    } else {
      this.setState({ validZip: false });
    }
  }

  isFormValid = () => {
    return !this.state.noMerchant && this.state.validZip;
  }

  handleSearch = (evt) => {
    evt.preventDefault();
    this.setState({ showResults: true });
    let timerid = null;
    if (timerid) { clearTimeout(timerid); }
    timerid = setTimeout(() => {
      window.scrollTo({ behavior: 'smooth', top: 500 })
    }, 200);
  }

  handleSelection = (selection) => {
    this.setState({
      selected: selection,
      merchantSelected: true
    });
  }

  render() {
    return (
      <div className="page-findmerchant pb-4">
        <Container fluid>

          <Row className="mt-md-3 mb-2 mb-md-4 justify-content-center">
            <Col md={10} lg={9} xl={7}>
              <h1 className="mb-1">Find A Merchant</h1>
              <p className="mb-1"><strong className="text-primary">Step 2 of 3</strong>&nbsp; Locate a merchant near you that accepts LendingUSA</p>
            </Col>
          </Row>

          <Row className="mb-4 pb-1 justify-content-center">
            <Col md={10} lg={9} xl={7}>
              <Card className="h-100 mb-0 border-primary pull-30">
                <CardBody>
                  <h5 className="mb-3">Please enter merchant name <i className="text-primary">or</i> merchant industry <i className="text-primary">near</i> your location</h5>
                  <Form className="inline-fill mb-2">
                    <Row form>
                      <Col md={4}>
                        <FormGroup className="mb-0">
                          <Label for="merchant-name">Merchant Name</Label>
                          <Input type="text" name="merchant-name" id="MerchantName" />
                        </FormGroup>
                      </Col>
                      <Col md={1} className="connector">OR</Col>
                      <Col md={4}>
                        <FormGroup className="mb-0">
                          <Label for="industry">Industry</Label>
                          <Input type="select" name="industry" id="Industry">
                            <option disabled selected>Select One...</option>
                            <option value="audiology">Audiology</option>
                            <option value="bariatrics">Bariatrics</option>
                            <option value="chiropractic">Chiropractic</option>
                            <option value="cosmeticsurgery">Cosmetic Surgery</option>
                            <option value="dental">Dental</option>
                            <option value="dermatology">Dermatology</option>
                            <option value="fertility">Fertility</option>
                            <option value="funeral">Funeral</option>
                            <option value="generalhealthcare">General Healthcare</option>
                            <option value="hairrestoration">Hair Restoration</option>
                            <option value="lasikvision">Lasik &amp; Vision</option>
                            <option value="medspa">MedSpa</option>
                            <option value="medicaldevices">Medical Devices</option>
                            <option value="veterinary">Veterinary</option>
                            <option value="petretail">Pet Retail</option>
                            <option value="bridal">Bridal</option>
                            <option value="legal">Legal</option>
                            <option value="taxdebtrelief">Tax Debt Relief</option>
                            <option value="tutoring">Tutoring</option>
                            <option value="consumergoods">Consumer Goods</option>
                            <option value="debtconsolidation">Debt Consolidation</option>
                            <option value="homeimprovement">Home Improvement</option>
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={1} className="connector">NEAR</Col>
                      <Col md={2}>
                        <FormGroup className="mb-0">
                          <Label for="zip-code">Zip Code</Label>
                          <Input
                            type="tel"
                            name="zip-code"
                            id="Zipcode"
                            maxLength="5"
                            onChange={this.handleFormValidation}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                  <Row>
                    <Col md="auto">
                      <CustomInput
                        type="checkbox"
                        className="mb-2" id="NoMerchant"
                        label="I don’t have a specific merchant"
                        onChange={this.handleNoMerchantCheck}
                      />
                    </Col>
                    <Col md={4} className="ml-auto">
                      <Button
                        color="primary"
                        className="w-100"
                        type="submit"
                        disabled={!this.isFormValid()}
                        onClick={this.handleSearch}
                      >Search</Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <Row id="FindMerchantResults" className={`mt-3 mb-4 justify-content-center animated fadeInUp ${this.state.showResults ? 'd-flex' : 'd-none'}`}>
            <Col md={10} lg={9} xl={7}>
              <h3 className="pb-1 border-bottom">Search Results</h3>

              <Row className={`pt-2 pb-2 results-item ${this.state.selected === 1 ? 'selected' : ''}`} key="1" onClick={() => this.handleSelection(1)}>
                <Col xs={6} sm={4} className="d-flex align-items-center pl-0">
                  <div className="list-count">1</div>
                  <h4 className="mb-0">
                    Petland (Kennesaw)
                    <img src="/images/nfda-member.png" alt="NFDA Member" width="103" className="d-block mt-1" />
                  </h4>
                </Col>
                <Col xs={6} sm={4} className="d-flex align-items-center">
                  <small>1234 Merchant St.<br />
                  Kennessaw, GA 12345<br />
                  (555) 456-7890</small>
                </Col>
                <Col xs={6} sm={2} className="d-flex align-items-center ml-auto mb-2 mb-md-0 mt-1 mt-md-0">
                  <small><strong>3.2 mi</strong>&nbsp;<br className="d-none d-md-block" />
                  from 60640</small>
                </Col>
                <Col sm={2} className="d-flex align-items-center pl-0 pr-0">
                  {this.state.selected === 1 ?
                    <Button tag="div" size="sm" color="success" className="w-100">Selected</Button> :
                    <Button tag="div" size="sm" color="primary" className="w-100">Select</Button>
                  }
                </Col>
              </Row>

              <Row className={`pt-2 pb-2 results-item ${this.state.selected === 2 ? 'selected' : ''}`} key="2" onClick={() => this.handleSelection(2)}>
                <Col xs={6} sm={4} className="d-flex align-items-center pl-0">
                  <div className="list-count">2</div>
                  <h4 className="mb-0">Pet Supply (Kennesaw)</h4>
                </Col>
                <Col xs={6} sm={4} className="d-flex align-items-center">
                  <small>1234 Merchant St.<br />
                  Kennessaw, GA 12345<br />
                  (555) 456-7890</small>
                </Col>
                <Col xs={6} sm={2} className="d-flex align-items-center ml-auto mb-2 mb-md-0 mt-1 mt-md-0">
                  <small><strong>4.1 mi</strong>&nbsp;<br className="d-none d-md-block" />
                  from 60640</small>
                </Col>
                <Col sm={2} className="d-flex align-items-center pl-0 pr-0">
                  {this.state.selected === 2 ?
                    <Button tag="div" size="sm" color="success" className="w-100">Selected</Button> :
                    <Button tag="div" size="sm" color="primary" className="w-100">Select</Button>
                  }
                </Col>
              </Row>

              <Row className={`pt-2 pb-2 results-item ${this.state.selected === 3 ? 'selected' : ''}`} key="3" onClick={() => this.handleSelection(3)}>
                <Col xs={6} sm={4} className="d-flex align-items-center pl-0">
                  <div className="list-count">3</div>
                  <h4 className="mb-0">
                    Petland (Cobb)
                    <img src="/images/nfda-member.png" alt="NFDA Member" width="103" className="d-block mt-1" />
                  </h4>
                </Col>
                <Col xs={6} sm={4} className="d-flex align-items-center">
                  <small>1234 Merchant St.<br />
                  Kennessaw, GA 12345<br />
                  (555) 456-7890</small>
                </Col>
                <Col xs={6} sm={2} className="d-flex align-items-center ml-auto mb-2 mb-md-0 mt-1 mt-md-0">
                  <small><strong>14.75 mi</strong>&nbsp;<br className="d-none d-md-block" />
                  from 60640</small>
                </Col>
                <Col sm={2} className="d-flex align-items-center pl-0 pr-0">
                  {this.state.selected === 3 ?
                    <Button tag="div" size="sm" color="success" className="w-100">Selected</Button> :
                    <Button tag="div" size="sm" color="primary" className="w-100">Select</Button>
                  }
                </Col>
              </Row>

              <Row className={`pt-2 pb-2 results-item ${this.state.selected === 4 ? 'selected' : ''}`} key="4" onClick={() => this.handleSelection(4)}>
                <Col xs={6} sm={4} className="d-flex align-items-center pl-0">
                  <div className="list-count">4</div>
                  <h4 className="mb-0">Petland (Kennesaw)</h4>
                </Col>
                <Col xs={6} sm={4} className="d-flex align-items-center">
                  <small>1234 Merchant St.<br />
                  Kennessaw, GA 12345<br />
                  (555) 456-7890</small>
                </Col>
                <Col xs={6} sm={2} className="d-flex align-items-center ml-auto mb-2 mb-md-0 mt-1 mt-md-0">
                  <small><strong>3.2 mi</strong>&nbsp;<br className="d-none d-md-block" />
                  from 60640</small>
                </Col>
                <Col sm={2} className="d-flex align-items-center pl-0 pr-0">
                  {this.state.selected === 4 ?
                    <Button tag="div" size="sm" color="success" className="w-100">Selected</Button> :
                    <Button tag="div" size="sm" color="primary" className="w-100">Select</Button>
                  }
                </Col>
              </Row>

              <Row className={`pt-2 pb-2 results-item ${this.state.selected === 5 ? 'selected' : ''}`} key="5" onClick={() => this.handleSelection(5)}>
                <Col xs={6} sm={4} className="d-flex align-items-center pl-0">
                  <div className="list-count">5</div>
                  <h4 className="mb-0">Pet Supply (Kennesaw)</h4>
                </Col>
                <Col xs={6} sm={4} className="d-flex align-items-center">
                  <small>1234 Merchant St.<br />
                  Kennessaw, GA 12345<br />
                  (555) 456-7890</small>
                </Col>
                <Col xs={6} sm={2} className="d-flex align-items-center ml-auto mb-2 mb-md-0 mt-1 mt-md-0">
                  <small><strong>4.1 mi</strong>&nbsp;<br className="d-none d-md-block" />
                  from 60640</small>
                </Col>
                <Col sm={2} className="d-flex align-items-center pl-0 pr-0">
                  {this.state.selected === 5 ?
                    <Button tag="div" size="sm" color="success" className="w-100">Selected</Button> :
                    <Button tag="div" size="sm" color="primary" className="w-100">Select</Button>
                  }
                </Col>
              </Row>

              <Row className={`pt-2 pb-2 results-item ${this.state.selected === 6 ? 'selected' : ''}`} key="6" onClick={() => this.handleSelection(6)}>
                <Col xs={6} sm={4} className="d-flex align-items-center pl-0">
                  <div className="list-count">6</div>
                  <h4 className="mb-0">Petland (Cobb)</h4>
                </Col>
                <Col xs={6} sm={4} className="d-flex align-items-center">
                  <small>1234 Merchant St.<br />
                  Kennessaw, GA 12345<br />
                  (555) 456-7890</small>
                </Col>
                <Col xs={6} sm={2} className="d-flex align-items-center ml-auto mb-2 mb-md-0 mt-1 mt-md-0">
                  <small><strong>14.75 mi</strong>&nbsp;<br className="d-none d-md-block" />
                  from 60640</small>
                </Col>
                <Col sm={2} className="d-flex align-items-center pl-0 pr-0">
                  {this.state.selected === 6 ?
                    <Button tag="div" size="sm" color="success" className="w-100">Selected</Button> :
                    <Button tag="div" size="sm" color="primary" className="w-100">Select</Button>
                  }
                </Col>
              </Row>

              <Loader className="mt-3" />

            </Col>
          </Row>

        </Container>

        <div id="ContinueButtonContainer" className={ `animated slideInUp faster ${this.state.merchantSelected ? 'd-flex' : 'd-none'}` }>
          <Button tag={Link} to="/dtc/approved" id="ContinueButton" size="lg" color="primary">Check My Rate <img src="/icons/arrow-right-lg.svg" alt="" /></Button>
        </div>

      </div>
    );
  }
}

export default DTCFindMerchant;
